import { ISagaModule } from 'redux-dynamic-modules-saga';
import { reduxKey } from './constants';
import { reduxModuleLoaded } from './actions/editor';
import { moduleLoadableSaga } from './sagas';
import reducers from './reducers';

export function getEditorModule(): ISagaModule<any> {
  return {
    id: 'editorModule',
    reducerMap: {
      [reduxKey as string]: reducers,
    },
    sagas: [moduleLoadableSaga],
    retained: false,
    initialActions: [reduxModuleLoaded()],
  };
}
